/* Estilos padrões para os lists */
import theme from 'theme';

export const listStyles = {
    redText: { color: 'red' },
    addButton: {
        height: 42,
        display: 'flex',
        alignItems: 'center'
    },
    iconGroup: {
        display: 'inline-flex',
        gap: 5
    },
    actionIcon: {
        fontSize: 24,
        color: theme.palette.primary.main,
        cursor: 'pointer'
    },
    filterPaper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '10px 20px',
        gap: 15
    },
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30
};

/* Eventos padrões dos ícones */
// altera a cor do ícone ao passar o cursor
export const handleListIconMouseEnter = (event) => {
    event.currentTarget.style.color = theme.palette.secondary.main;
};

// retorna à cor padrão do ícone ao remover o cursor
export const handleListIconMouseLeave = (event) => {
    event.currentTarget.style.color = theme.palette.primary.main;
};

// altera a cor do ícone de exclusão ao passar o cursor
export const handleListDeleteIconMouseEnter = (event) => {
    event.currentTarget.style.color = 'red';
};

/* SessionStorage dos lists */
// recupera um objeto salvo no sessionStorage
export const loadStoredJson = (key, defaultValue) => {
    const storedValue = sessionStorage.getItem(key);

    return storedValue ? JSON.parse(storedValue) : defaultValue;
};

// salva um valor no sessionStorage
export const saveStoredValue = (key, value) => {
    sessionStorage.setItem(
        key,
        typeof value === 'object' ? JSON.stringify(value) : value
    );
};

// remove uma lista de chaves do sessionStorage
export const removeStoredKeys = (keys) => {
    keys.forEach(key => sessionStorage.removeItem(key));
};

/* Montagem de query params dos lists */
export const buildListParams = ({
    page,
    rowsPerPage,
    sortField,
    sortOrder,
    filters = []
}) => {
    const params = new URLSearchParams();

    params.append('page', page + 1);
    params.append('limit', rowsPerPage);

    if (sortField) {
        params.append('sort', sortField);
    }

    if (sortOrder) {
        params.append('sortOrder', sortOrder);
    }

    filters.forEach(({ field, value, operator }) => {
        if (
            value === undefined ||
            value === null ||
            value === '' ||
            value === 'T' ||
            (Array.isArray(value) && value.length === 0)
        ) {
            return;
        }

        if (operator) {
            params.append(field, `${operator}${value}`);

            return;
        }

        params.append(field, value);
    });

    return `?${params.toString()}`;
};

/* Retorno padrão das APIs paginadas */
// retorna os registros da consulta
export const getListData = (response) => {
    return response.data.data || [];
};

// retorna o total de registros
export const getTotalRecords = (response) => {
    return parseInt(response.data.info && response.data.info.totalrecords, 10) || 0;
};